// @flow

import React, { Component } from 'react';

import { History } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { signup, setAuthForm, setFormErrors, unsetError } from '../../actions/auth';
import { fieldError, genericFormError } from '../../store/reducers/auth';
import PasswordInput from '../shared/PasswordInput';
import AuthInput from '../shared/AuthInput';
import AuthError from '../shared/AuthError';
import Button from '../shared/Button';
import type { AuthState, FormError } from '../../store/reducers/auth';
import validate from '../../validators/signup';
import Text from '../shared/Typography';

type State = {
  feedback: ?{
    suggestions: string[],
    warning: string
  },
  score: ?number,
  passwordChecked: boolean,
  showPassword: boolean
};

type AuthForm = {
  email?: string,
  password?: string
}

type Props = {
  history: History,
  auth: {
    email: string,
    password: string,
    authenticated: boolean,
    error: ?string,
    loading: boolean
  },
  location: any,
  formError: FormError,
  signup: (email: string, password: string) => Promise<void>,
  unsetError: (field: string) => void,
  setFormErrors: (errors: FormError[]) => void,
  fieldError: (field: string) => FormError,
  setAuthForm: (form: AuthForm) => void,
  heading: ?string,
  noSubHeading: ?boolean,
  signupOverride: (email: string, password: string) => Promise<void>
} & WithTranslation

class Signup extends Component<Props, State> {
  state: State = {
    feedback: null,
    score: null,
    passwordChecked: false,
    showPassword: false
  }

  props: Props

  componentWillMount() {
    this.resetForm();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.resetForm();
    }
  }

  resetForm() {
    this.props.setAuthForm({
      password: ''
    });
    this.props.setFormErrors([]);
  }

  onSubmit = (event: SyntheticEvent<HTMLFormElement>): void => {
    event.preventDefault();
    const localErrors = validate({
      email: this.props.auth.email,
      password: this.props.auth.password
    });
    this.props.setFormErrors(localErrors);
    if (localErrors.length < 1) {
      if (this.props.signupOverride) {
        this.props.signupOverride(this.props.auth.email, this.props.auth.password);
      } else {
        this.props.signup(this.props.auth.email, this.props.auth.password);
      }
    }
  }

  onChange = (event: SyntheticEvent<HTMLInputElement>): void => {
    this.props.unsetError(event.currentTarget.name);
    this.props.setAuthForm({
      [event.currentTarget.name]: event.currentTarget.value || ''
    });
  }

  togglePassword = () => {
    this.setState({
      showPassword: !this.state.showPassword
    });
  }

  render() {
    const { heading, noSubHeading, t } = this.props;
    return (
      <React.Fragment>
        <div className='auth-page__header'>
          <Text h1>{heading || t('welcome')}</Text>
          {!noSubHeading && <Text paragraph>{t('use_to_access')}</Text>}
        </div>
        <form onSubmit={this.onSubmit} noValidate className='auth-form--signup is-functional'>
          <div className='auth-form__row'>
            <AuthInput
              value={this.props.auth.email}
              onChange={this.onChange}
              name='email'
              type='email'
              label={t('email')}
              error={this.props.fieldError('email') && <AuthError error={this.props.fieldError('email')} />}
              noValidate
            />
          </div>
          <PasswordInput
            password={this.props.auth.password}
            onChange={this.onChange}
            error={this.props.fieldError('password') && <AuthError error={this.props.fieldError('password')} />}
          />
          <div className='auth-form__errors'>
            <AuthError error={this.props.formError} />
          </div>
          <Button
            formButton
            label={t('sign_up')}
            loading={this.props.auth.loading}
          />
        </form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (appState: { auth: AuthState }) => ({
  auth: appState.auth,
  fieldError: (field) => fieldError(appState.auth, field),
  formError: genericFormError(appState.auth)
});

export default withTranslation('signup')(
  connect(mapStateToProps, {
    signup,
    setAuthForm,
    setFormErrors,
    unsetError
  })(Signup)
);



// WEBPACK FOOTER //
// ./src/components/pages/signup.js